angular.module('workflow.app')

.factory( 'Model', ( Utils ) ->

  class Model

    @extend = ( destination, prototype ) ->
      for property, val of prototype
        destination[ property ] = val

      destination

    @decorate = ( object ) ->
      self = @
      @extend( object, @:: )
      object.init()

      # Override resource instance methods so we don't lose decoration upon calling them
      for method in [ '$update', '$get', '$save' ]
        if object[ method ]
          # So... when you declare a variable within a for loop (oldMethod), CoffeeScript
          # declares it *outside* the for loop, which is opposite to everything you learn in
          # JavaScript schools, and thus clearly a source for bugs. While I'm sure there's a good
          # reason for it, it sucks nevertheless. We use a superfluous do statement to make sure
          # oldMethod is declared inside the for loop. Stupid I hear you say. I feel you man.
          do( method ) ->
            oldMethod = object[ method ]

            # If we don't include this check then we will repeatedly decorate this method
            # which recursively invokes `decorate`. This makes the call stack grow
            # exponentially and leads to it overflowing.
            if oldMethod.isDecorated
              return

            newMethod = (params, success, error) ->
              oldMethod.call( @, params, success, error  ).then ( resource ) ->
                self.decorate( resource )
            newMethod.isDecorated = true
            object[ method ] = newMethod

      object

    init: ->
      # By default an empty method. Descendants will override

    reload: ->
      @$get( id: @id )

    # TODO: Refactor. Really shouldn't be here. Should be encapsulated by models (custom/curated sources)
    toResource: ( items, resourceClass ) ->
      if @isArray( items )
        return items.map( (item) -> new resourceClass( item ) )
      else
        return new resourceClass( items )

    # TODO: Get rid of completely. Used by toResource but won't be needed after refactoring as Collection/Model will take care of this
    isArray: ( value ) ->
      value and
        typeof value is 'object' and
        value instanceof Array and
        typeof value.length is 'number' and
        typeof value.splice is 'function' and
        not ( value.propertyIsEnumerable 'length' )


    # TODO: Refactor. Shouldn't be here. Should become a method on Model. Used for custom curated sources.
    markAsDirty: ( resource ) ->
      resource.$$dirty = true

)
